module.exports = __webpack_public_path__ + "img/banner.675e3eee.jpg";